import { createAction, props } from "@ngrx/store";
import {UserInterface} from '@core/model/user/user.interface';

export const loggedUser = createAction("[Auth] loadLoggedUser");
export const loggedUserSuccess = createAction(
  "[Auth] logged user success",
  props<{ user: UserInterface }>()
);
